import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { Alerts } from '../components/notify';
import { UserCode, Token, config, API_URL, API_IMAGES } from './Include';
import { useDispatch } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import './Topbar.css'
import Icon from './IconComponent'


const Topbar = () => {
  const dispatch = useDispatch()
  const [student, setStudent] = useState([] as any)
  const [steps, setSteps] = useState({
    session:'',
    program:'',
    title:''
  })
  const [isFullScreen, setIsFullScreen] = useState(false)
  const [showNotifications, setShowNotifications] = useState(false)
  const [showUserMenu, setShowUserMenu] = useState(false)
  // Track sidebar state for toggle icon (synced from Template via event)
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 992)
  const [notifications, setNotifications] = useState([
    { id: 1, message: 'New announcement posted', time: '5 mins ago', read: false },
    { id: 2, message: 'Assignment deadline extended', time: '1 hour ago', read: false },
    { id: 3, message: 'New course material available', time: '2 days ago', read: true }
  ])
  
  const notificationRef = useRef<HTMLDivElement>(null)
  const userMenuRef = useRef<HTMLDivElement>(null)
  const isMobile = useMediaQuery({ maxWidth: 768 })

  const FetchContent =()=>{
    if(UserCode){

      
      let url = API_URL+'/student/profile/'+UserCode;
      axios.get(url, config).then(response=>{
    
        if(response.data.status===200){
          dispatch({
            type:'SET_RECORDS',
            name:'student',
            data:response.data.data[0]
        })
        
setStudent(response.data.data[0]);
        }else{
          window.location.href='/logout'
        }
  }).catch((error)=>{
        Alerts('danger', 'Error!',  error.message)
   window.location.href='/logout'
    })
    }else{
    window.location.href='/logout'
    }
}

useEffect(() => {
  FetchContent()

  // Handle clicks outside dropdown menus
  const handleClickOutside = (event: MouseEvent) => {
    if (notificationRef.current && !notificationRef.current.contains(event.target as Node)) {
      setShowNotifications(false)
    }
    if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
      setShowUserMenu(false)
    }
  }

  // Sync sidebar icon state from Template's authoritative state
  const handleSidebarStateChanged = (e: CustomEvent) => {
    setSidebarOpen(e.detail.isOpen)
  }

  document.addEventListener('mousedown', handleClickOutside)
  window.addEventListener('sidebar-state-changed', handleSidebarStateChanged)
  return () => {
    document.removeEventListener('mousedown', handleClickOutside)
    window.removeEventListener('sidebar-state-changed', handleSidebarStateChanged)
  }
}, [])

// Toggle fullscreen mode
const toggleFullScreen = () => {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen().then(() => {
      setIsFullScreen(true)
    })
  } else if (document.exitFullscreen) {
    document.exitFullscreen().then(() => {
      setIsFullScreen(false)
    })
  }
}

// Mark all notifications as read
const markAllAsRead = () => {
  setNotifications(notifications.map(notification => ({ ...notification, read: true })))
}

// Count unread notifications
const unreadCount = notifications.filter(notification => !notification.read).length
  return (
    <header className="app-header sticky no-print" style={{'marginBottom': '-65px'}}>
      <div className="main-container container-fluid">
        <div className="topbar-container">
          {/* Left section */}
          <div className="topbar-left">
            <div className="responsive-logo">
              <a className="main-logo" href="/">
                <img src="/images/edc.png" className="logo" alt="EDC logo" />
              </a>
            </div>
            
            <button
              className={`menu-toggle-btn ${sidebarOpen ? 'is-open' : ''}`}
              onClick={() => window.dispatchEvent(new CustomEvent('toggle-sidebar'))}
              aria-label="Toggle sidebar"
            >
              <span className="toggle-bar top-bar"></span>
              <span className="toggle-bar mid-bar"></span>
              <span className="toggle-bar bot-bar"></span>
            </button>
            
            <div className="session-info">
              <h3 className="session-title text-white font-weight-bold"> ENTREPRENEURSHIP DEVELOPMENT CENTER REGISTRATION PORTAL</h3>
            </div>
          </div>
    
          {/* Right section */}
          <div className="topbar-right">
            {/* Search bar */}
            
            {/* Action buttons */}
            <div className="action-buttons">
              {/* Fullscreen toggle */}
              <button 
                className="action-btn" 
                onClick={toggleFullScreen}
                aria-label="Toggle fullscreen"
              >
                {isFullScreen ? <Icon name="compress" size={18} /> : <Icon name="expand" size={18} />}
              </button>
              
           
              
              
              {/* User profile */}
              <div className="user-profile-container" ref={userMenuRef}>
                <button 
                  className="user-profile-btn" 
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  aria-label="User menu"
                >
                  <img 
                    className="user-avatar" 
                    src={API_IMAGES+'/'+student.gender+'.png'} 
                    alt="User avatar" 
                  />
                </button>
                
                {showUserMenu && (
                  <div className="user-dropdown">
                    <div className="user-dropdown-header">
                      <div className="user-info">
                        <h5 className="user-name">{student.full_name}</h5>
                        <span className="user-level">{student.matric_no}</span>
                      </div>
                    </div>
                    <div className="user-dropdown-body">
                      <a className="user-dropdown-item" href="/app/profile">
                        <Icon name="user" size={16} className="dropdown-icon" />
                        <span>Profile</span>
                      </a>
                      <a className="user-dropdown-item" href="/app/portal/password">
                        <Icon name="cog" size={16} className="dropdown-icon" />
                        <span>Change Password</span>
                      </a>
                      <a className="user-dropdown-item" href="/logout">
                        <Icon name="sign-out" size={16} className="dropdown-icon" />
                        <span>Log out</span>
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </header>
  )
}

export default Topbar